export default __webpack_public_path__ + "static/media/noitems.846cc072.svg";